import styled from 'styled-components';
import {colors} from "../utils/variables.styles";

const ContainerHeaderWrapper = styled.div`
  width: 100%;
  background: ${colors.white};
  margin-bottom: 30px;
  border-bottom: 10px solid  ${colors.mainRed};
`;

export {
  ContainerHeaderWrapper
};
